import { render, staticRenderFns } from "./content5.vue?vue&type=template&id=d28a2b20&scoped=true&"
import script from "./content5.vue?vue&type=script&lang=js&"
export * from "./content5.vue?vue&type=script&lang=js&"
import style0 from "./content5.vue?vue&type=style&index=0&id=d28a2b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28a2b20",
  null
  
)

export default component.exports